module.exports = __webpack_public_path__ + "media/assets/images/tour/2_Tour_4-e8ca262043855b5bb793f1b5ad88f4b3.png";